import { Action, ErrorMessage } from '../types/common.types';
import { Dispatch } from 'redux';
import { ACTION_TYPES } from '../constants/actions';

export interface ErrorState {
  data: ErrorMessage[];
}

const initialState = {
  data: []
};

export const setErrorData = (data: ErrorMessage[] = []) => (
  dispatch: Dispatch
) => {
  dispatch({ type: ACTION_TYPES.ERROR.SET_ERROR_DATA, data });
};

export const errorReducer = (
  state: ErrorState = initialState,
  action: Action
): ErrorState => {
  switch (action.type) {
    case ACTION_TYPES.ERROR.SET_ERROR_DATA: {
      return {
        ...state,
        data: action.data as ErrorMessage[]
      };
    }
    default: {
      return state;
    }
  }
};
